import { Pause } from "lucide-react";

type PauseBannerProps = {
  downgradeTime?: Date | string;
  firstName: string;
  isOwner?: boolean;
  onUpgrade: () => void;
  state: "paused" | "pending";
};

export function PauseBanner({
  downgradeTime,
  firstName,
  isOwner,
  onUpgrade,
  state,
}: PauseBannerProps) {
  const formattedDate = downgradeTime
    ? new Intl.DateTimeFormat("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric",
      }).format(new Date(downgradeTime))
    : "your pause date";

  const title =
    state === "pending"
      ? `Hi ${firstName} \u{1F44B}, your plan will be paused soon`
      : `Hi ${firstName} \u{1F44B}, your plan is currently paused.`;

  const description =
    state === "pending"
      ? `You'll keep full access through ${formattedDate}, then you'll still be able to create drafts and access your files anytime.`
      : `All active requests are on hold, but you can upgrade anytime and pick up right where you left off.`;

  const ctaPrefix =
    state === "pending" ? "Changed your mind?" : "Ready to jump back in?";

  return (
    <div className="flex pb-4 justify-center">
      <div className="flex gap-4 rounded-xl border border-border-secondary bg-bg-primary p-4 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] w-full">
        <div className="grid size-10 shrink-0 place-items-center rounded-full bg-bg-warning-secondary">
          <Pause className="text-text-warning-primary" size={25} />
        </div>
        <div className="flex flex-1 flex-col gap-1">
          <span className="text-sm font-semibold text-text-primary">
            {title}
          </span>
          <span className="text-sm text-text-primary">{description}</span>
          {isOwner && (
            <p className="mt-1 text-sm font-semibold text-text-tertiary">
              {ctaPrefix}{" "}
              <button
                className="text-text-brand-primary hover:underline cursor-pointer"
                onClick={onUpgrade}
                type="button"
              >
                Upgrade your plan
              </button>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
